<template>
    <Notice v-if="isLogin && showLogo" class="log-notice" @click="handleShowLog"/>

    <!-- 公告｜更新日志 -->
	<xl-announcement
		ref="updateLogRef"
		:isHasImg="isHasImg"
		:updateLogList="updateLogList"
		:updateLogInfo="updateLogInfo"
		:lang="$doLang($lang())"
		@activeLogChange="handleActiveLogChange"
		@announcementClose="handleAnnouncementLogClose"
		@logClose="handleLogClose">
	</xl-announcement>
</template>

<script setup>
import {
	$doLang,
	$lang,
	$convertUTCDateToLocalDate,
	$setLocalStorage,
	$getLocalStorage,
	$decodeHtml,
	$getCdnUrl
} from '@/assets/common/common';
import { Notice } from '@shining3d/icons-vue';
import commonApi from '@/api/common';
import { XlAnnouncement } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';

defineProps({
	showLogo: {
		type: Boolean,
		default: true
	}
});

const updateLogRef = ref( null );

const handleShowLog = () => {
	getAnnouncement( 'updateLog' );
};

const updateLogList = ref([]);
const getAnnouncement = async ( type ) => {
	let announcementList = [];
	const lang = $doLang( $lang());
	const res = await commonApi.getAnnouncement({ lang, pushTarget: 'openCloud', pageSize: 999, skipMaxPageSize: true, page: 1 });
	if ( res.status === 'success' && Array.isArray( res.result ) && res.result.length > 0 ) {
		if ( type === 'announcement' ) { // 公告
			const logListIds = $getLocalStorage( 'logListIds' ) || [];
			if ( !res.result[ 0 ]?.isExpire && logListIds.every(( val ) => val !== res.result[ 0 ]?.id )){
				announcementList = res.result.map(( val ) => ({
					...val,
					title: val.title,
					releaseOn: $convertUTCDateToLocalDate( val.releaseOn, 'YYYY-MM-DD' )
				}));
				updateLogList.value = announcementList;
				console.log( 'updateLogList.value:', updateLogList.value );
				await getVersionInfo( announcementList[ 0 ]);
				updateLogRef.value && ( updateLogRef.value.dialogVisible = true );
			}
		} else if ( type === 'updateLog' ) { // 更新日志
			announcementList = res.result.map(( val ) => ({
				...val,
				releaseOn: $convertUTCDateToLocalDate( val.releaseOn, 'YYYY-MM-DD' )
			}));
			updateLogList.value = announcementList;
			updateLogRef.value && ( updateLogRef.value.logDialogVisible = true );
			await getVersionInfo( announcementList[ 0 ]);
		}
	}
};

const updateLogInfo = ref([]);
const isHasImg = ref( true );
const checkLogItem = ref({});
const getVersionInfo = async ( item ) => {
	if ( checkLogItem.value?.id === item.id ) { return; }
	checkLogItem.value = item;
	const resData = await commonApi.getUpdateLogDetail({ pushID: item.id });
	if ( resData.status === 'success' && Array.isArray( resData.result ) && resData.result.length > 0 ) {
		let hasImg = false;
		const tmpData = resData.result.map(( val ) => {
			if ( val.subResult && val.subResult.length > 0 ) {
				val.subResult = val.subResult.map(( subVal ) => {
					if ( subVal.banners.length > 0 ) {
						hasImg = true;
					}
					return {
						...subVal,
						description: $decodeHtml( subVal.description || '' ),
						imgList: subVal.banners?.map(( v ) => {
							let tmpUrl = v.dfsID && $getCdnUrl( v );
							if ( !( v.name.includes( '.mp4' ) || v.name.includes( 'gif' ))) {
								tmpUrl += '?x-oss-process=image/format,jpg/interlace,1';
							}
							return {
								...v,
								url: tmpUrl,
								filename: v?.name
							};
						}) || []
					};
				});
			}
			if ( val.banners.length > 0 ) {
				hasImg = true;
			}
			return {
				...val,
				description: $decodeHtml( val.description || '' ),
				imgList: val.banners?.map(( v ) => {
					let tmpUrl = v.dfsID && $getCdnUrl( v );
					if ( !( v.name.includes( '.mp4' ) || v.name.includes( 'gif' ))) {
						tmpUrl += '?x-oss-process=image/format,jpg/interlace,1';
					}
					return {
						...v,
						url: tmpUrl,
						filename: v?.name || ''
					};
				}) || [],
				carouselImgList: val.banners.map(( v ) => ({
					...v,
					imgSrc: v.dfsID && $getCdnUrl( v ),
					link: ''
				})) || []
			};
		});
		isHasImg.value = hasImg;
		updateLogInfo.value = tmpData;
		console.log( '🚀 ~ file: home.vue:291 ~ getVersionInfo ~ updateLogInfo.value:', updateLogInfo.value );
	} else {
		updateLogInfo.value = [];
	}
};

const handleActiveLogChange = async ({ item, index }, callback ) => {
	console.log( 'handleActiveLogChange', item, index );
	await getVersionInfo( item );
	const cb = true;
	callback( cb );
};

const handleAnnouncementLogClose = () => {
	$setLocalStorage( 'logListIds', updateLogList.value.map(( val ) => val?.id ));
};

const handleLogClose = () => {
	updateLogInfo.value = [];
	checkLogItem.value = {};
	$setLocalStorage( 'logListIds', updateLogList.value.map(( val ) => val?.id ));
};

const isLogin = Boolean( VueCookieNext.getCookie( 'token' ));
// onMounted(() => {
// if ( isLogin ) {
// getAnnouncement( 'announcement' );
// }
// });

defineExpose({ getAnnouncement });
</script>

<style scoped lang="scss">
.log-notice {
    width: 20px;
    height: 20px;
    margin-right: 20px;
    cursor: pointer;
    :deep(path) {
        fill: $color-n8;
    }
    :deep(rect) {
        fill: $color-n8;
    }
    &:hover {
        :deep(path) {
            fill: $color-b4;
        }
        :deep(rect) {
            fill: $color-b4;
        }
    }
}
</style>
